import { render, staticRenderFns } from "./Incidences.vue?vue&type=template&id=7ca31484"
import script from "./Incidences.vue?vue&type=script&lang=js"
export * from "./Incidences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports